// Deterministic color palette for vendor categories on the visitor map.
// Slugs come from the seeded `vendor_categories` table; anything not listed
// falls back to a hash-into-palette so newly-added admin categories still
// get a stable color.

const PALETTE = [
  '#E07856', // warm coral
  '#7BAFD4', // sky blue
  '#9BC4A0', // sage green
  '#D4A373', // warm tan
  '#B07AA1', // muted plum
  '#F4A261', // amber
  '#56828F', // teal
  '#C77DFF', // lavender
  '#5C4D7D', // deep purple
  '#8C5E58', // mahogany
  '#A1A883', // olive
  '#D88C9A', // dusty rose
];

const SLUG_OVERRIDES = {
  'wood-working': '#8C5E58',
  'stained-glass': '#7BAFD4',
  'laser-engraving': '#5C4D7D',
  'pottery-ceramics': '#D4A373',
  jewelry: '#C77DFF',
  'textiles-sewing': '#B07AA1',
  'paper-crafts': '#9BC4A0',
  metalwork: '#56828F',
  'painting-fine-art': '#E07856',
  'soap-candles': '#F4A261',
  other: '#9e9e9e',
};

const hashSlug = (slug) => {
  let hash = 0;
  for (let i = 0; i < slug.length; i++) {
    hash = (hash * 31 + slug.charCodeAt(i)) >>> 0;
  }
  return hash;
};

export const getCategoryColor = (slug) => {
  if (!slug) return '#9e9e9e';
  if (SLUG_OVERRIDES[slug]) return SLUG_OVERRIDES[slug];
  return PALETTE[hashSlug(slug) % PALETTE.length];
};

// Tile colors for cell types that don't carry a vendor category. Booths
// without a registered vendor share a neutral "available" tile so the eye
// is drawn to the rich, category-colored booths.
export const CELL_COLORS = {
  walkway: '#efe7d8',
  food: '#f4a261',
  empty: '#ffffff',
  boothEmpty: '#e8e2d1',
  boothBorder: '#b8a98a',
  boothLabel: '#5b4636',
  boothLabelOnDark: '#ffffff',
  selected: '#2e7d32',
  highlightRing: '#f57f17',
};

// Soft text color that pairs with each tile background. We want booth labels
// to stay legible on the colored tiles without relying on a single shade.
export const getBoothLabelColor = (slug) => {
  if (!slug) return CELL_COLORS.boothLabel;
  // The brighter palette colors get white text; the darker ones get warm dark.
  const lightOn = new Set([
    'pottery-ceramics',
    'soap-candles',
    'paper-crafts',
    'textiles-sewing',
  ]);
  return lightOn.has(slug) ? CELL_COLORS.boothLabel : CELL_COLORS.boothLabelOnDark;
};
